import cx from 'classnames';
import { useNavigate } from 'react-router-dom';
import { Button, ButtonVariants } from '@components/button/Button';
import { Error } from '@components/error/Error';
import typography from '~styles/typography.scss';
import styles from './CheckoutForm.scss';
import { PaymentMethods } from './PaymentMethods';
import { useOfferCheckout } from './useOfferCheckout';

interface OfferCheckoutForm {
  disabled: boolean;
  offerAmount: number;
}

export const OfferCheckoutForm = ({
  disabled,
  offerAmount,
}: OfferCheckoutForm) => {
  const navigate = useNavigate();
  const {
    handleOnClickSendOffer,
    paymentMethods,
    selectedPaymentMethodId,
    setupFutureCardUsage,
    handleOnChangePaymentMethod,
    handleOnChangeName,
    handleOnChangeCardElement,
    handleOnChangeSaveCard,
    handleOnDeletePaymentMethod,
    isLoading,
    isPayButtonDisabled,
    checkoutResponseError,
  } = useOfferCheckout(offerAmount);

  if (isLoading) {
    return null;
  }

  return (
    <form id="payment-form" onSubmit={handleOnClickSendOffer}>
      <PaymentMethods
        paymentMethods={paymentMethods}
        selectedPaymentMethodId={selectedPaymentMethodId}
        setupFutureCardUsage={setupFutureCardUsage}
        handleOnChangePaymentMethod={handleOnChangePaymentMethod}
        handleOnChangeName={handleOnChangeName}
        handleOnChangeCardElement={handleOnChangeCardElement}
        handleOnChangeSaveCard={handleOnChangeSaveCard}
        handleOnDeletePaymentMethod={handleOnDeletePaymentMethod}
      />
      <p className={cx(typography.t2, styles.offerNotice)}>
        Your credit card will not be charged unless the offer is accepted
      </p>
      <Error message={checkoutResponseError} />
      <Button
        className={styles.bookAndPay}
        isDisabled={isPayButtonDisabled || disabled}
        label="Send Offer"
        type="submit"
        variant={ButtonVariants.Primary}
      />
      <Button
        className={styles.cancel}
        label="Cancel"
        onClick={() => navigate(-1)}
        variant={ButtonVariants.Tertiary}
      />
    </form>
  );
};
